import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useIntl, FormattedMessage } from "react-intl";
import { useSnackbar } from "notistack";
import StaticCriteriaQuestions from "../Authentication/pages/StaticRegistrations";
import { prepareStaticAppForm } from "../../utils/utilityFunctions";
// Services
import { updateStakeholder } from "../../../services/Stakeholder";
// RTK
import { setCurrentStakeholder } from "../../../redux/features/stakeholder/stakeholderSlice";
import { fetchToken } from "../../../redux/features/login/loginActions";
import { fetchNotifications } from "../../../redux/features/notifications/notificationActions";
import { InstitutionVoens } from "../StakeholderCabinet/utils/constants";

const RegisterAppEdit = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const intl = useIntl();
  const history = useHistory();

  // Redux
  const { person, selectedIndustryCategory } = useSelector(
    (state) => state.login
  );

  const { currentStakeholder, structureName } = useSelector(
    (state) => state.stakeholder
  );
  const [currentSHolder, setCurrentSHolder] = useState(currentStakeholder);

  // Static Registration Disabled Button
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const stakeholerPhoto = currentStakeholder?.photo?.[0] || null;
    if (stakeholerPhoto) {
      setCurrentSHolder({ ...currentSHolder, photo: stakeholerPhoto });
    }
  }, []);

  // const checkIsInstitution = (structureName) => {
  //   return structureNameList.some((v) => v.structureName == structureName);
  // };

  const checkIsInstitution = (voen) => {
    const voenList = Object.values(InstitutionVoens).filter((item) => item);
    return Boolean(voenList.includes(voen));
  };

  const validateAction = () => {
    if (
      currentStakeholder?.voen &&
      selectedIndustryCategory?.name?.az !== "Bələdçilər" &&
      !checkIsInstitution(currentStakeholder.voen)
    ) {
      return Yup.object().shape({
        legalAddress: Yup.string().required(
          intl.formatMessage({ id: "error.required" })
        ),
        objectName: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(512, intl.formatMessage({ id: "error.too_long" })),
        objectAddress: Yup.object().shape({
          label: Yup.string()
            .required(intl.formatMessage({ id: "error.required" }))
            .min(3, intl.formatMessage({ id: "error.too_short" }))
            .max(512, intl.formatMessage({ id: "error.too_long" })),
          lat: Yup.number().nullable(),
          lng: Yup.number().nullable(),
        }),
        objectCode: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(512, intl.formatMessage({ id: "error.too_long" })),
        personInChargeName: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(30, intl.formatMessage({ id: "error.too_long" })),
        personInChargePosition: Yup.object().shape({
          az: Yup.string()
            .required(intl.formatMessage({ id: "error.required" }))
            .min(3, intl.formatMessage({ id: "error.too_short" }))
            .max(50, intl.formatMessage({ id: "error.too_long" })),
          en: Yup.string()
            .optional()
            .min(3, intl.formatMessage({ id: "error.too_short" }))
            .max(50, intl.formatMessage({ id: "error.too_long" })),
          ru: Yup.string()
            .optional()
            .min(3, intl.formatMessage({ id: "error.too_short" }))
            .max(50, intl.formatMessage({ id: "error.too_long" })),
        }),
        personInChargePhone: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(12, intl.formatMessage({ id: "error.too_short" })),
        managerName: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(30, intl.formatMessage({ id: "error.too_long" })),
        website: Yup.string()
          .nullable()
          .optional()
          .url("error.url")
          .max(50, intl.formatMessage({ id: "error.too_long" })),
        brandName: Yup.string()
          .optional()
          .min(2, intl.formatMessage({ id: "error.too_short" }))
          .max(512, intl.formatMessage({ id: "error.too_long" }))
          .nullable(),
        email: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .email(intl.formatMessage({ id: "error.email" }))
          .min(8, intl.formatMessage({ id: "error.too_short" }))
          .max(128, intl.formatMessage({ id: "error.too_long" }))
          .nullable(),
        phone: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(12, intl.formatMessage({ id: "error.too_short" }))
          .nullable(),
        photo: Yup.array().test({
          message: <FormattedMessage id="error.photo_not_selected" />,
          test: (arr) => {
            if (!arr?.length) return false;
            return arr.length > 0;
          },
        }),
      });
    } else if (checkIsInstitution(currentStakeholder.voen)) {
      return Yup.object().shape({
        nationality: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(512, intl.formatMessage({ id: "error.too_long" })),
        email: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .email(intl.formatMessage({ id: "error.email" }))
          .min(8, intl.formatMessage({ id: "error.too_short" }))
          .max(128, intl.formatMessage({ id: "error.too_long" })),
        personInChargePhone: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(12, intl.formatMessage({ id: "error.too_short" })),
      });
    } else if (
      selectedIndustryCategory?.name?.az?.toLowerCase() ===
      "yerləşmə vasitələri"
    ) {
      return Yup.object().shape({
        bedCount: Yup.string().required(),
        roomCount: Yup.string().required(),
      });
    } else {
      return Yup.object().shape({
        nationality: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(512, intl.formatMessage({ id: "error.too_long" })),
        email: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .email(intl.formatMessage({ id: "error.email" }))
          .min(8, intl.formatMessage({ id: "error.too_short" }))
          .max(128, intl.formatMessage({ id: "error.too_long" })),
        phone: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(12, intl.formatMessage({ id: "error.too_short" })),
        photo: Yup.array().test({
          message: <FormattedMessage id="error.photo_not_selected" />,
          test: (arr) => {
            if (!arr?.length) return false;
            return arr.length > 0;
          },
        }),
      });
    }
  };

  const formik = useFormik({
    initialValues: currentStakeholder,
    enableReinitialize: true,
    validationSchema: validateAction(),

    onSubmit: (values) => {
      signWithASAN();
    },
  });

  useEffect(() => {
    if (
      Object.entries(formik.touched).length === 0 &&
      Object.entries(formik.errors).length === 0
    ) {
      setDisabled(false);
    } else {
      if (
        Object.entries(formik.touched).length !== 0 &&
        Object.entries(formik.errors).length === 0
      ) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    }
  }, [formik]);

  const signWithASAN = async () => {
    try {
      if (!currentStakeholder.voen) {
        await submitGradeAppEdit();
        return;
      }
      await submitGradeAppEdit();
    } catch (err) {
      enqueueSnackbar(
        intl.formatMessage({ id: err?.response?.data.message || err.message }),
        { variant: "error" }
      );
    }
  };

  const submitGradeAppEdit = async () => {
    try {
      const stakeholderData = {
        certificateNumber: currentStakeholder?.certificateNumber,
        certificate: currentStakeholder?.certificate,
        industryCategory: currentStakeholder?.industryCategory?._id,
      };

      let updatedModel = null;
      const isAccommodation = currentStakeholder?.industryCategory?.name?.az?.toLowerCase() === "yerləşmə vasitələri";
      
      if (
        currentStakeholder?.voen &&
        selectedIndustryCategory?.name?.az !== "Bələdçilər".toLowerCase() &&
        !checkIsInstitution(currentStakeholder.voen)
      ) {
        updatedModel = {
          name: formik.values.name?.trim(),
          brandName: formik.values.brandName?.trim(),
          email: formik.values.email?.trim(),
          phone: formik.values.phone,
          managerName: formik.values.managerName?.trim(),
          personInChargeName: formik.values.personInChargeName?.trim(),
          personInChargePosition: formik.values.personInChargePosition,
          personInChargePhone: formik.values.personInChargePhone,
          photo: formik.values.photo,
          isVoen: formik.values.isVoen,
          // Additional fields that were missing
          legalAddress: formik.values.legalAddress?.trim(),
          objectAddress: formik.values.objectAddress,
          objectName: formik.values.objectName?.trim(),
          objectCode: formik.values.objectCode?.trim(),
          objectRegisterationDate: formik.values.objectRegisterationDate,
          city: formik.values.city,
          website: formik.values.website?.trim(),
          groupOfCompanies: formik.values.groupOfCompanies?.trim(),
        };
        
        // Add accommodation-specific fields
        if (isAccommodation) {
          updatedModel.roomCount = formik.values.roomCount;
          updatedModel.bedCount = formik.values.bedCount;
        }
      } else if (checkIsInstitution(currentStakeholder.voen)) {
        updatedModel = {
          name: formik.values.name?.trim(),
          nationality: formik.values.nationality?.trim(),
          personInChargeEmail: formik.values.email?.trim(),
          personInChargeName: formik.values.personInChargeName?.trim(),
          personInChargePosition: formik.values.personInChargePosition,
          personInChargePhone: formik.values.personInChargePhone,
          isVoen: formik.values.isVoen,
        };
      } else {
        updatedModel = {
          nationality: formik.values.nationality?.trim(),
          email: formik.values.email?.trim(),
          phone: formik.values.phone,
          photo: formik.values.photo,
          isVoen: formik.values.isVoen,
          isGuide: formik.values.isGuide,
          city: formik.values.city,
        };
      }
      const form = await prepareStaticAppForm(
        stakeholderData,
        updatedModel,
        "PUT",
        formik.values.isVoen,
        false,
        selectedIndustryCategory
      );

      form.person = currentStakeholder?.person;
      form.pin = currentStakeholder?.person?.pin;

      let resp = await updateStakeholder(currentStakeholder._id, form);

      if (resp?.data) {
        enqueueSnackbar(intl.formatMessage({ id: resp?.message }), {
          variant: "success",
        });
        await dispatch(setCurrentStakeholder(resp?.data));
        await dispatch(fetchToken({ id: resp.data?._id }));
        dispatch(fetchNotifications(resp.data?._id));
        setTimeout(() => {
          history.replace("/stakeholder/new");
        }, 500);
      } else {
        enqueueSnackbar("Response data is not found", { variant: "error" });
      }
    } catch (err) {
      enqueueSnackbar(
        intl.formatMessage({ id: err?.response?.data.message || err?.message }),
        { variant: "error" }
      );
    }
  };

  return (
    <div className="col-md-12">
      <StaticCriteriaQuestions
        isInstitution={checkIsInstitution(currentStakeholder.voen)}
        appView={false}
        person={person}
        selectedIndustryCategory={currentStakeholder.industryCategory}
        stakeholder={currentStakeholder}
        formik={formik}
        structureName={structureName}
        selectedObjectName={{ name: currentStakeholder.objectName }}
        disabled={disabled}
        notViewPhoto="notShow"
        voenInput="voenInput"
        registerAppEdit={true}
        handleSubmit={formik.handleSubmit}
      />
    </div>
  );
};

export default RegisterAppEdit;
